<template>
    <v-container>
        <v-row class="contentRow">
            <v-col>
                <h1 class="text-left darkColor--text">Flow-Down Submitter View</h1>
			</v-col>
			<v-col cols="12">
				<p class="darkColor--text">
					This is your overview of audits that you have been sent.
					Pending audits await your attention.
					<br />Completed audits have been submitted, you will not be notified of any future status changes.
				</p>
			</v-col>
            <v-tabs background-color="transparent" light centered icons-and-text>
                <v-tab>
                    Pending
                    <v-icon>fas fa-history fa-flip-horizontal</v-icon>
                </v-tab>

                <v-tab class="submitted">
                    Submitted
                    <v-icon>fas fa-check</v-icon>
                </v-tab>
                <v-tab-item>
					<br />
                    <v-card elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Pending Audits</h3>
                        </v-card-title>
                        <v-data-table
                            :loading="loading"
                            theme--
                            light
                            :headers="headersPending"
                            :items="pendingaudits"
                            :items-per-page="20"
                            class="light table mx-4 pending-table"
							:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.complete="{ item }">
                                <v-btn
                                    :to="'/auditflowdown/flowdownsubmitter/'+item.id"
                                    color="primary"
                                    label
                                    small
                                >
                                    {{item.complete}}
                                    Complete
                                    <v-icon right small>fas fa-pencil-alt</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                        <br />
                    </v-card>
                    <br />
                </v-tab-item>
                <v-tab-item>
                    <br />
                    <v-card elevation="0" outlined>
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="darkColor--text">Submitted Audit Requests</h3>
                        </v-card-title>
                        <v-data-table
                            :loading="loading"
                            theme--
                            light
                            :headers="headersCompleted"
                            :items="completedaudits"
                            :items-per-page="20"
                            class="light table mx-4 completed-table"
							:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.view="{ item }">
                                <v-btn
                                    :to="'/auditflowdown/flowdownaudits/'+item.id"
                                    color="primary"
                                    label
                                    small
                                >
                                    {{item.view}}
                                    View
                                    <v-icon right small>far fa-eye</v-icon>
                                </v-btn>
                            </template>
							<template v-slot:item.flowDownAgain="{ item }">
                                <v-btn
                                    :to="`/auditflowdown/flowdownauditor/newflowdown/${item.template}/${item.templateID}/${item.id}`"
                                    color="primary"
                                    label
                                    small
                                >
                                    {{item.flowDownAgain}}
                                    Flow-Down
                                    <v-icon right small>fas fa-turn-down</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                        <br />
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-row>
    </v-container>
</template>

<script>
import AuditRequestsAPI from "../../api/audit/request"
import AuditsAPI from "../../api/audit/audit"
import LoadingState from "../../consts/LoadingState"
export default {
	name: "SupplierAuditFlowDownOverview",

	data() {
		return {
			headersPending: [
				// {
				// 	text: "Audit ID",
				// 	align: "start",
				// 	sortable: false,
				// 	value: "id",
				// 	class: "secondary--text"
				// },
				{
					text: "Auditor",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				}
			],

			headersCompleted: [
				// {
				// 	text: "Audit ID",
				// 	align: "start",
				// 	sortable: false,
				// 	value: "id",
				// 	class: "secondary--text"
				// },
				{
					text: "Auditor",
					value: "recipient",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Flow-Down again",
					value: "flowDownAgain",
					sortable: false,
					class: "darkColor--text"
				}
			],

			pendingaudits: [],
			completedaudits: [],
			id: false,
			client: false,
			timestamp: false,
			template: false,
			dialogDelete: false,
			loading: false,
		}
	},
	mounted() {
		this.loadPendingAudits()
		this.loadCompletedAudits()
		let createAccess = this.$accessToOperation("AU", "C")
		if (createAccess) {
			this.headersPending.push(
				{
					text: "Complete",
					value: "complete",
					sortable: false,
					class: "secondary--text"
				}
			)
		}
	},

	methods: {
		loadCompletedAudits() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditsAPI.list({type: "outgoing", flowDown:1})
				.then(result => {
					this.completedaudits = []
					for (let entry of result.items) {
						this.completedaudits.push({
							id: entry.id,
							recipient: entry.recipientName || entry.recipient,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							template: entry.templateName,
							view: null,
							templateID:entry.templateID
						})
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadPendingAudits() {
			let createAccess = this.$accessToOperation("AU", "C")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditRequestsAPI.list({type:"incoming", flowDown:1})
				.then(result => {
					this.pendingaudits = []
					for (let entry of result.items) {
						this.pendingaudits.push({
							id: entry.requestID,
							sender: entry.senderName || entry.sender,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							template: entry.templateName,
							complete: createAccess ? null : undefined
						})
					}
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		}
	}
}
</script>
<style>
.completed-table thead th {
    font-size: 14px !important;
}
.pending-table thead th {
    font-size: 14px !important;
}
</style>
